import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../../../store/app";
import { fetchCareerDetails } from "../../Utils/slice";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Card, Image, Skeleton } from "antd";
import { WebConstant } from "../../../../webConstant/WebConstant";
import BreadcrumbComponent from "../../../../CommonComponent/BreadcrumbComponent";
import { CareerDetailsBreadcrumb } from "../../../../../../config/BreadcrumbConfig";
import { formatGlobalPrice } from "../../../../../../config/Global";

const CareerDetailsPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const { careerId } = useParams();
  const [detailsModalData, setDetailsModalData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (careerId) {
      showCareerDetails(careerId);
    }
  }, [careerId]);

  const showCareerDetails = (id: any) => {
    setIsLoading(true); // Start loading
    dispatch(fetchCareerDetails(id))
      .then((data: any) => {
        setDetailsModalData(data.data);
        setIsLoading(false); // Stop loading when data arrives
      })
      .catch((e: any) => {
        console.error("Failed to fetch career details:", e);
        setIsLoading(false); // Stop loading on error
      });
  };

  const stripHtml = (html: string) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };



  const IframeVideourl = ({ url }: any) => {
    const auto = '?autoplay=1';
    var step2 = [''];
    var step1 = [''];
    if(url.includes('youtube.com'))
    {
      step1 = url.split('v=');
      step2 = step1[1].split('&');
    }
    else if(url.includes('youtu.be'))
    {
      step1 = url.split('?');
      step2 = step1[0].split('/');
    }
    console.log(step1,step2);
    return <iframe title="YouTube Video" src={'https://www.youtube.com/embed/' + step2[0] + auto + '&playlist='+ step2[0] +'&mute=1&loop=1&showinfo=0&modestbranding=1&rel=0'} allowFullScreen allow="autoplay; encrypted-media" ></iframe>
  }


  const AccordianArray: any = [];
  if (detailsModalData?.description) {
    AccordianArray.push({
      key: "1",
      label: "",
      children: (
        <div className="boxInnerContent" style={{ marginTop: 0 }}>
          <div>
            {detailsModalData?.video_url && (
              <div className="ant-col-xl-24 ant-col-lg-24 ant-col-md-24 ant-col-sm-24 ant-col-xs-24">
                <div className="careerResultVideo">
                  <div className="responsive-iframe-container">
                    <IframeVideourl url={detailsModalData?.video_url}></IframeVideourl>
                    {/* <iframe
                      src={`https://www.youtube.com/embed/${detailsModalData?.video_url?.split("v=")[1]
                        }?autoplay=1&mute=1`}
                      title="YouTube Video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe> */}
                  </div>
                </div>
              </div>
            )}
            {detailsModalData?.file && (
              <div className="ant-col-xl-24 ant-col-lg-24 ant-col-md-24 ant-col-sm-24 ant-col-xs-24">
                <div className="careerResultImage">
                  <div className="responsive-iframe-container">
                    <Image
                      width={"100%"}
                      src={WebConstant?.IMAGE_URL + detailsModalData?.file}
                    />
                  </div>
                </div>
              </div>
            )}
            {detailsModalData?.name && (
              <div
                className="ant-col-xl-24 ant-col-lg-24 ant-col-md-24 ant-col-sm-24 ant-col-xs-24"
                style={{ marginTop: 16, marginBottom: 12 }}
              >
                <h4
                  style={{
                    fontFamily: "Outfit, sans-serif",
                    fontSize: 24,
                    fontWeight: 400,
                    color: "#000000",
                  }}
                >
                  {detailsModalData.name}
                </h4>
              </div>
            )}
            <div
              className={
                "ant-col-md-24 ant-col-sm-24 ant-col-xs-24 " +
                (detailsModalData?.video_url || detailsModalData?.file
                  ? "ant-col-xl-24 ant-col-lg-24"
                  : "ant-col-xl-24 ant-col-lg-24")
              }
            >
              <div
                className="cmsInnerContent"
                style={{
                  fontFamily: "Outfit, sans-serif",
                  fontSize: 18,
                  fontWeight: 300,
                  color: "#222424",
                  marginTop: 4,
                }}
                dangerouslySetInnerHTML={{
                  __html: stripHtml(detailsModalData.description),
                }}
              ></div>
            </div>
          </div>
        </div>
      ),
    });
  }

  if (detailsModalData?.knowledge_skills) {
    AccordianArray.push({
      key: "2",
      label: (
        <div className="analystTitle">
          <h4
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 24,
              fontWeight: 400,
              color: "#000000",
            }}
          >
            Knowledge/Skills
          </h4>
        </div>
      ),
      children: (
        <div className="boxInnerContent">
          <div
            className="cmsInnerContent"
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 18,
              fontWeight: 300,
              color: "#222424",
              marginTop: 4,
            }}
            dangerouslySetInnerHTML={{
              __html: stripHtml(detailsModalData?.knowledge_skills),
            }}
          ></div>
        </div>
      ),
    });
  }

  if (
    detailsModalData?.education_training ||
    detailsModalData?.experience ||
    detailsModalData?.credentialing
  ) {
    AccordianArray.push({
      key: "3",
      label: (
        <div className="analystTitle">
          <h4
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 24,
              fontWeight: 400,
              color: "#000000",
            }}
          >
            Requirements
          </h4>
        </div>
      ),
      children: (
        <div className="boxInnerContent" style={{ marginTop: 16 }}>
          {(detailsModalData?.education_training ||
            detailsModalData?.experience) && (
              <Row gutter={[24, 16]}>
                {detailsModalData?.education_training && (
                  <Col xs={24} sm={12}>
                    <div className="requirementSubHeader">
                      <h4
                        style={{
                          fontFamily: "Outfit, sans-serif",
                          color: "#222424",
                          fontSize: 18,
                          fontWeight: 300,
                        }}
                      >
                        Education/Training
                      </h4>
                      <div
                        className="cmsInnerContent"
                        style={{
                          fontFamily: "Outfit, sans-serif",
                          fontSize: 18,
                          fontWeight: 300,
                          color: "#222424",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: stripHtml(detailsModalData.education_training),
                        }}
                      ></div>
                    </div>
                  </Col>
                )}
                {detailsModalData?.experience && (
                  <Col xs={24} sm={12}>
                    <div className="requirementSubHeader">
                      <h4
                        style={{
                          fontFamily: "Outfit, sans-serif",
                          color: "#222424",
                          fontSize: 18,
                          fontWeight: 300,
                        }}
                      >
                        Experience
                      </h4>
                      <div
                        className="cmsInnerContent"
                        style={{
                          fontFamily: "Outfit, sans-serif",
                          fontSize: 18,
                          fontWeight: 300,
                          color: "#222424",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: stripHtml(detailsModalData.experience),
                        }}
                      ></div>
                    </div>
                  </Col>
                )}
              </Row>
            )}
          {detailsModalData?.credentialing && (
            <div className="requirementSubHeader" style={{ marginTop: 16 }}>
              <h4
                style={{
                  fontFamily: "Outfit, sans-serif",
                  fontSize: 24,
                  fontWeight: 400,
                  color: "#000000",
                }}
              >
                Credentialing (Required/Optional)
              </h4>
              <div
                className="cmsInnerContent"
                style={{
                  fontFamily: "Outfit, sans-serif",
                  fontSize: 18,
                  fontWeight: 300,
                  color: "#222424",
                  marginTop: 4,
                }}
                dangerouslySetInnerHTML={{
                  __html: stripHtml(detailsModalData.credentialing),
                }}
              ></div>
            </div>
          )}
        </div>
      ),
    });
  }

  AccordianArray.push({
    key: "4",
    label: (
      <div className="analystTitle">
        <h4
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: 24,
            fontWeight: 400,
            color: "#000000",
          }}
        >
          Salary range
        </h4>
      </div>
    ),
    children: (
      <div className="boxInnerContent">
        <div
          className="cmsInnerContent"
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: 18,
            fontWeight: 300,
            color: "#222424",
            marginTop: 4,
          }}
        >
          {formatGlobalPrice(detailsModalData?.salary_start)} -{" "}
          {formatGlobalPrice(detailsModalData?.salary_end)}
        </div>
      </div>
    ),
  });

  if (detailsModalData?.career_path_moves_from_this_role) {
    AccordianArray.push({
      key: "5",
      label: (
        <div className="analystTitle">
          <h4
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 24,
              fontWeight: 400,
              color: "#000000",
            }}
          >
            Career path moves from this role
          </h4>
        </div>
      ),
      children: (
        <div className="boxInnerContent">
          <div
            className="cmsInnerContent"
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 18,
              fontWeight: 300,
              color: "#222424",
              marginTop: 4,
            }}
            dangerouslySetInnerHTML={{
              __html: stripHtml(
                detailsModalData.career_path_moves_from_this_role
              ),
            }}
          ></div>
        </div>
      ),
    });
  }

  if (detailsModalData?.career_details && detailsModalData?.career_details?.length > 0) {
    AccordianArray.push({
      key: "6",
      label: (
        <div className="analystTitle">
          <h4
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 24,
              fontWeight: 400,
              color: "#000000",
            }}
          >
            Career Categories
          </h4>
        </div>
      ),
      children: (
        <div className="boxInnerContent">
          {
            detailsModalData?.career_details?.map((item: any) =>
              <>
                <div className="cmsInnerContent">
                  <p style={{
                    margin: '1rem 0',
                    fontSize: 20,
                    backgroundColor: '#f5f5f5',
                    padding: '1rem',
                    borderRadius:'0.5rem'
                  }}>
                    <strong>{item.title}</strong>
                  </p>
                </div>
                <div
                  className="cmsInnerContent"
                  style={{
                    marginLeft: '1rem',
                    fontFamily: "Outfit, sans-serif",
                    fontSize: 18,
                    fontWeight: 300,
                    color: "#222424",
                    marginTop: 4,
                  }}
                  dangerouslySetInnerHTML={{
                    // __html: stripHtml(item),
                    __html: item.description,
                  }}
                ></div>
              </>

            )
          }
        </div >
      ),
    });
  }

  return (
    <section className="dashboard-sec career-details">
      <div className="container-fluid" >
        <div
          className="breadcrumb has-button"
        >
          <BreadcrumbComponent
            key={1}
            items={
              CareerDetailsBreadcrumb(
                detailsModalData?.name || "Career Details"
              ).path
            }
          />
        </div>

        <Card
          style={{
            borderRadius: 16,
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            padding: 0,
            width: "100%",
          }}
          styles={{body:{ padding: "32px 24px"}}}
          // bodyStyle={{ }}
        >
          {isLoading ? (
            // Show multiple skeleton rows while loading
            <>
              <Skeleton avatar paragraph={{ rows: 1 }} active />
            </>
          ) : (
            AccordianArray?.length > 0 &&
            AccordianArray?.map((section: any) => (
              <div key={section.key} style={{ marginBottom: 28 }}>
                {section.label}
                {section.children}
              </div>
            ))
          )}
        </Card>
      </div>
    </section>
  );
};

export default CareerDetailsPage;
